import {NgModule} from '@angular/core';
import {SharedModule} from '../../app-common/shared.module';
import {authorRoutingComponents, AuthorRoutingModule} from './author-routing.module';
import {AuthorUrlResolverService} from './services/author-url-resolver.service';
import {StaticAuthorService} from './services/static-author.service';

@NgModule({
  declarations: [authorRoutingComponents],
  imports: [SharedModule, AuthorRoutingModule],
  providers: [AuthorUrlResolverService, StaticAuthorService],
  exports: [],
})
export class AuthorModule {}
